import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const TaskProccessingUI = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default TaskProccessingUI;
